import { Shield, LogOut, X } from 'lucide-react';
import { useState } from 'react';

export function DemoModeBanner() {
  const [dismissed, setDismissed] = useState(false);
  const isDemo = localStorage.getItem('erp_demo_mode') === 'true';
  if (!isDemo || dismissed) return null;

  const handleExit = () => {
    localStorage.removeItem('erp_token');
    localStorage.removeItem('erp_user');
    localStorage.removeItem('erp_demo_mode');
    window.location.href = '/';
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-[#0033A0] to-[#1e3a5f] text-white px-4 py-2.5 flex items-center justify-between shadow-lg" data-testid="demo-mode-banner">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Shield size={16} className="text-[#d4a84b]" />
        <span>Demo Mode — View only. Data modifications are restricted.</span>
      </div>
      <div className="flex items-center gap-2">
        <button onClick={handleExit} className="bg-white/20 hover:bg-white/30 text-white px-4 py-1.5 rounded-md text-xs font-semibold flex items-center gap-1.5 transition-colors" data-testid="exit-demo-btn">
          <LogOut size={14} /> Exit Demo
        </button>
        <button onClick={() => setDismissed(true)} className="p-1 hover:bg-white/10 rounded transition-colors" data-testid="dismiss-demo-btn"><X size={16} /></button>
      </div>
    </div>
  );
}

export function useDemoMode() {
  return localStorage.getItem('erp_demo_mode') === 'true';
}
